module.exports = __webpack_public_path__ + "img/ic_32_sport_handball.0062b13c.svg";